<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-indigo text-white" inline-actions>
        {{ goodsInfo.Goods_Name }}
        <q-badge :label="goodsInfo.Goods_Code" color="red" text-color="white"/>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-select
          filled
          label="انتخاب انبار"
          use-chips
          behavior="menu"
          :options="summaryItems"
          option-value="id"
          option-label="id"
          v-model="selectedCompany"/>
      <q-select
          class="q-mt-xs"
          filled
          label="انتخاب طرف معامله"
          use-chips
          use-input
          behavior="menu"
          :options="customerList"
          option-value="Cs_Name"
          option-label="Cs_Name"
          @filter="filterFn"
          v-model="customerSearchField"/>
    </q-card-section>
    <q-card-section align="center" class="q-pa-none">
      <q-chip square label="موجودی کل">
        <q-badge class="q-ml-xs" :color="lodash.sumBy(summaryItems, 'summed')>0?'green-10':'red-10'"
                 :label="lodash.sumBy(summaryItems, 'summed')"/>
      </q-chip>
      <q-chip square label="مبلغ کل"
              v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))">
        <q-badge class="q-ml-xs" :color="lodash.sumBy(summaryItems, 'summedPrice')>0?'green-10':'red-10'"
                 :label="lodash.sumBy(summaryItems, 'summedPrice').toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section align="center" class="q-pa-none">
      <q-chip square v-for="(item, index) in summaryItems" :label="item.id" :key="index">
        <q-badge class="q-ml-xs" :color="item.summed>0?'green-10':'red-10'" text-color="white" :label="item.summed"/>
        <q-badge v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v))"
                 class="q-ml-xs" :color="item.summedPrice>0?'green-10':'red-10'" text-color="white"
                 :label="item.summedPrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="itemsOptions"
          flat
          wrap-cells
          bordered
          virtual-scroll
          :hide-header="$q.screen.lt.md"
          :pagination="pagination"
          :filter="filterGoods">
        <template v-slot:header>
          <tr class="my-class text-center text-bold">
            <td></td>
            <td>طرف معامله</td>
            <td>تاریخ</td>
            <td>شماره سند</td>
            <td>شماره فاکتور</td>
            <td>شرح سند</td>
            <td>انبار</td>
            <td>کسر/اضافه</td>
            <td v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v)) || $store.state.roles.some(v=>['admin','salemanager'].includes(v))">
              قیمت
            </td>
            <td v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v)) || $store.state.roles.some(v=>['admin','salemanager'].includes(v))">
              قیمت کل
            </td>
            <td>موجودی</td>
            <td>انبارگردانی</td>
            <td>مغایرت انبارگردانی</td>
            <td>تایید کننده</td>
          </tr>
        </template>
        <template v-slot:body="props">
          <tr v-if="!$q.screen.lt.md" class="my-class">
            <td>
              <q-btn icon="delete" color="red-10" @click="removeFromList(props.row)" round flat
                     v-if="$store.state.roles.some(v=>['can_remove_item_from_goods_store'].includes(v)) || false">
                <q-tooltip>
                  حذف از کارتکس
                </q-tooltip>
              </q-btn>
            </td>
            <td class="text-bold">
              <q-chip v-if="props.row.Cs_Name"
                      square icon="person" :label="props.row.Cs_Name"
                      :clickable="
                      (props.row.GoEvent_Ind===311 &&  $store.state.roles.some(v=>['admin','user_purchase'].includes(v))) ||
                      (props.row.GoEvent_Ind===301 &&  $store.state.roles.some(v=>['admin','user_sell'].includes(v)))"
                      @click="getCustomerInfo(props.row.Sale_Cs_ID?props.row.Sale_Cs_ID:props.row.Buy_Cs_ID)"/>
            </td>
            <td class="text-center text-indigo-10 text-bold">{{ props.row.GoEvent_Date }}</td>
            <td class="text-center">
              <q-chip v-if="props.row.GoEvent_Num" square :label="props.row.GoEvent_Num" clickable/>
            </td>
            <td class="text-center">
              <q-chip v-if="props.row.Factor_Num" square :label="props.row.Factor_Num" clickable/>
            </td>
            <td style="min-width: 250px">{{ props.row.GoEvent_Desc }}</td>
            <td>
              <q-chip square :label="props.row.StorName" icon="store"/>
            </td>
            <td class="text-center">
              <q-chip class="" square :label="Math.abs(props.row.Inventory)" outline
                      :color="props.row.Inventory>0?'green-10':'red-10'"
                      :icon-right="props.row.Inventory>0?'arrow_upward':'arrow_downward'"/>
            </td>
            <td class="text-center"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v)) || $store.state.roles.some(v=>['admin','salemanager'].includes(v))">
              <q-chip class="" square
                      v-if="props.row.SaleG_PricePure || props.row.BuyG_PricePure"
                      :color="props.row.Inventory>0?'green-10':'red-10'"
                      :label="props.row.SaleG_PricePure?props.row.SaleG_PricePure.toLocaleString():props.row.BuyG_PricePure.toLocaleString()"
                      outline/>
            </td>
            <td class="text-center"
                v-if="!$store.state.roles.some(v=>['can_only_numerical_exists_store'].includes(v)) || $store.state.roles.some(v=>['admin','salemanager'].includes(v))">
              <q-chip class="" square
                      v-if="props.row.SaleG_PricePure || props.row.BuyG_PricePure"
                      :color="props.row.Inventory>0?'green-10':'red-10'"
                      :label="props.row.SaleG_PricePure?(Math.abs(props.row.Inventory) * props.row.SaleG_PricePure).toLocaleString():(Math.abs(props.row.Inventory) * props.row.BuyG_PricePure).toLocaleString()"
                      outline/>
            </td>
            <td class="text-center text-bold">
              <q-chip square :label="Math.abs(props.row.CumSum)" :color="props.row.CumSum>0?'green-10':'red-10'"
                      text-color="white"/>
            </td>
            <td class="text-center text-bold">
              <q-chip
                  v-if="(props.row.PhysicalCount || props.row.PhysicalCount===0) && ((props.row.ExistsBeforePhysicalCount-props.row.PhysicalCount) * -1!==0)"
                  square :label="props.row.PhysicalCount"/>
            </td>
            <td class="text-center text-bold">
              <span style="direction: ltr">
                <q-chip color="red-10" text-color="white" square
                        v-if="(props.row.ExistsBeforePhysicalCount-props.row.PhysicalCount) * -1!==0"
                        :label="(props.row.ExistsBeforePhysicalCount-props.row.PhysicalCount) * -1"/>
              </span>
            </td>
            <td class="text-center text-bold">
              <q-chip v-if="props.row.UserName" square :label="props.row.UserName" icon="support_agent"/>
            </td>
          </tr>
          <tr v-if="$q.screen.lt.md" :props="props" class="my-class">
            <q-card flat>
              <q-card-section horizontal>
                <q-card-section>
                  {{ props.row.GoEvent_Desc }}
                  <q-separator/>

                  <q-card-section>
                    <q-card-section class="no-padding">
                      <q-chip v-if="props.row.Cs_Name" square icon="person"
                              :label="props.row.Cs_Name"
                              :clickable="
                              (props.row.GoEvent_Ind===311 &&  $store.state.roles.some(v=>['admin','user_purchase'].includes(v))) ||
                              (props.row.GoEvent_Ind===301 &&  $store.state.roles.some(v=>['admin','user_sell'].includes(v)))"
                              @click="getCustomerInfo(props.row.Sale_Cs_ID?props.row.Sale_Cs_ID:props.row.Buy_Cs_ID)"/>
                      <q-chip v-if="props.row.GoEvent_Num" square color="deep-orange-10" text-color="white"
                              :label="props.row.GoEvent_Num"
                              clickable/>
                      <q-chip square :label="props.row.GoEvent_Date" clickable/>
                      <q-space/>
                      <q-chip v-if="props.row.Factor_Num" square :label="props.row.Factor_Num" clickable/>
                    </q-card-section>
                    <q-chip square :label="props.row.StorName" icon="store"/>
                    <q-chip v-if="props.row.UserName" square :label="props.row.UserName" icon="support_agent"/>
                    <q-space/>
                    <q-chip dense class="" square :label="Math.abs(props.row.Inventory)" outline
                            :color="props.row.Inventory>0?'green-10':'red-10'"
                            :icon-right="props.row.Inventory>0?'arrow_upward':'arrow_downward'"/>
                    <q-chip dense square :label="Math.abs(props.row.CumSum)"
                            :color="props.row.CumSum>0?'green-10':'red-10'"
                            text-color="white" :icon-right="props.row.CumSum>0?'arrow_upward':'arrow_downward'"/>
                  </q-card-section>
                  <q-card-section align="center">
                    <q-chip class="" square
                            v-if="props.row.SaleG_PricePure || props.row.BuyG_PricePure"
                            :color="props.row.Inventory>0?'green-10':'red-10'"
                            :label="props.row.SaleG_PricePure?props.row.SaleG_PricePure.toLocaleString():props.row.BuyG_PricePure.toLocaleString()"
                            outline/>
                    <q-chip class="" square
                            v-if="props.row.SaleG_PricePure || props.row.BuyG_PricePure"
                            :color="props.row.Inventory>0?'green-10':'red-10'"
                            :label="props.row.SaleG_PricePure?(Math.abs(props.row.Inventory) * props.row.SaleG_PricePure).toLocaleString():(Math.abs(props.row.Inventory) * props.row.BuyG_PricePure).toLocaleString()"
                            outline/>
                  </q-card-section>

                </q-card-section>
              </q-card-section>
            </q-card>
          </tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfoCartex :selected-customer="selectedCustomer" :dialog="true"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GoodsCartex",
  components: {
    'CustomerInfoCartex': () => import("@/components/customers/CustomerInfo")
  },
  props: {
    goodsInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customerSearchField: null,
      customerList: [],
      selectedCompany: null,
      summaryItems: [],
      pagination: {
        rowsPerPage: 10
      },
      items: [],
      itemsOptions: [],
      saleItems: [],
      filterGoods: '',
      filter: '',
      customerInfoDialog: false,
      selectedCustomer: '',
    }
  },
  methods: {
    ...mapActions({
      getCatrex: 'Products/getCartex',
      setCustomerInfo: 'Customers/get_customer_info',
      clearItemConfirmation: 'Products/clearGoodsStoreItemConfirm'
    }),
    removeFromList(rowInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف تاییدیه ها ردیف انتخابی اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.clearItemConfirmation({
          ID: rowInfo.ID,
          Goods_ID: rowInfo.Goods_ID
        }).then(() => {
          this.items = this.items.filter(item => item.ID !== rowInfo.ID)
          this.itemsOptions = this.itemsOptions.filter(item => item.ID !== rowInfo.ID)
        })
      })
    },
    filterFn(val, update) {
      if (val === '') {
        update(() => {
          this.customerList = this.lodash.uniq(this.items.filter(item => item.Cs_Name).map(item => item.Cs_Name))
        })
        return
      }
      update(() => {
        this.customerList = this.lodash.uniq(this.items.filter(item => item.Cs_Name && item.Cs_Name.indexOf(val) > -1).map(item => item.Cs_Name))
      })
    },

    getCustomerInfo: function (id) {
      this.setCustomerInfo(id).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
    reComputeData() {
      let cumsum = 0
      this.itemsOptions = this.itemsOptions.map(({
                                                   BuyG_PricePure,
                                                   Buy_Cs_ID,
                                                   Cs_Name,
                                                   G_Code,
                                                   General_Name,
                                                   GoEvent_Date,
                                                   GoEvent_Desc,
                                                   GoEvent_Ind,
                                                   GoEvent_Num,
                                                   Goods_ID,
                                                   ID,
                                                   Inventory,
                                                   SaleG_PricePure,
                                                   Sale_Cs_ID,
                                                   StorName,
                                                   StoreID,
                                                   UserName,
                                                   PhysicalCount,
                                                   ExistsBeforePhysicalCount,
                                                   Factor_Num
                                                 }) => ({
        BuyG_PricePure,
        Buy_Cs_ID,
        Cs_Name,
        G_Code,
        General_Name,
        GoEvent_Date,
        GoEvent_Desc,
        GoEvent_Ind,
        GoEvent_Num,
        Goods_ID,
        ID,
        Inventory,
        SaleG_PricePure,
        Sale_Cs_ID,
        StorName,
        StoreID,
        CumSum: cumsum += Inventory,
        UserName,
        PhysicalCount,
        ExistsBeforePhysicalCount,
        Factor_Num
      }));
    }
  },
  watch: {
    selectedCompany: function (val) {
      if (val) {
        this.itemsOptions = this.items.filter(item => item.StorName === val.id)
      } else {
        this.itemsOptions = this.items
      }
      this.reComputeData();
    },
    customerSearchField: function (val) {
      if (val) {
        this.itemsOptions = this.lodash.uniq(this.items.filter(item => item.Cs_Name && item.Cs_Name.indexOf(val) > -1))
      }
    }
  },
  created() {
    this.getCatrex(this.goodsInfo.Goods_ID).then((res) => {
      this.items = res;
      this.itemsOptions = this.items
      this.customerList = this.lodash.uniq(this.items.filter(item => item.Cs_Name).map(item => item.Cs_Name))
      this.summaryItems = this.lodash.map(this.lodash.groupBy(this.items, 'StorName'), (o, idx) => {
        return {
          id: idx,
          summed: this.lodash.sumBy(o, 'Inventory'),
          summedPrice: this.lodash.sumBy(o, item => (item.SaleG_PricePure && item.SaleG_PricePure ? -1 * item.Inventory : item.Inventory) * (item.SaleG_PricePure && item.SaleG_PricePure > 0 ? item.SaleG_PricePure : item.BuyG_PricePure))
        }
      })
      this.reComputeData();
    })
  }
}
</script>

<style lang="sass" scoped>
.my-sticky-header-column-table
  /* height or max-height is important */
  height: 310px

  /* specifying max-width so the example can
    highlight the sticky column on any browser window */
  max-width: 600px

  td:first-child
    /* bg color is important for td; just specify one */
    background-color: #00b4ff

  tr th
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #00b4ff

  /* this will be the loading indicator */

  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
    /* highest z-index */
    z-index: 3

  thead tr:first-child th
    top: 0
    z-index: 1

  tr:first-child th:first-child
    /* highest z-index */
    z-index: 3

  td:first-child
    z-index: 1

  td:first-child, th:first-child
    position: sticky
    left: 0

  /* prevent scrolling behind sticky top row on focus */

  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>